
import { Professions } from './professions.model';
import { Trainings } from './trainings.model';

export class CandidatesJobsAlert {
  private id: number;
  private level_of_study: string;
  private trainings: Trainings;
  private years_of_experience: string;
  private professions: Professions;

  constructor(CandidatesJobsAlert: any) {
    this.id = CandidatesJobsAlert.id;
    this.level_of_study = CandidatesJobsAlert.level_of_study;
    this.trainings = CandidatesJobsAlert.trainings;
    this.years_of_experience = CandidatesJobsAlert.years_of_experience;
    this.professions = CandidatesJobsAlert.professions;
  }

  getId(): number {
    return this.id;
  }

  getLevelOfStudy(): string {
    return this.level_of_study;
  }

  getTrainings(): Trainings {
    return this.trainings;
  }

  getYearsOfExperience(): string {
    return this.years_of_experience;
  }

  getProfessions(): Professions {
    return this.professions;
  }
}